import React from "react";
import { Radio, Space, Typography } from "antd";

/**
 * 排行表下鑽 drawer 的頭部 (通路統計與銷售方案統計共用)：範圍切換 + 這張圖到底統計了什麼。
 *
 * 「本期」= 排行表當下的區間,合計與被點開的那一列對得起來;其餘三顆是長跨度的粒度,
 * 看的是趨勢而非本期,所以一定要講明合計不一致——不標的話兩個數字擺在一起只會被當成資料有誤。
 *
 * @param scope    period | span (以回應為準,載入中才用目前的選擇)
 * @param type     day | month | year (長跨度的粒度;本期時粒度由後端依區間長度決定)
 * @param basis    stay | book,決定日期的身分是入住日還是訂房日
 * @param from,to  後端實際採用的區間;尚未回來時傳 null,不顯示上一次的區間
 * @param onChange 收到被選到的值 (period | day | month | year)
 */
export default function DetailScopeHeader({ scope, type, basis, from, to, onChange }) {
  const book = basis === "book";
  const ready = Boolean(from && to);
  // 進單維度的排行表欄位是淨進單,明細只畫新增,差額是先天的,只能講清楚
  const note =
    scope === "period"
      ? book
        ? "合計等於排行表的新增 (不含取消，故與淨進單有差)"
        : "合計與排行表一致"
      : "此跨度超出排行表區間，合計與排行表不一致";

  return (
    <>
      <Space style={{ marginBottom: 2 }} wrap>
        <Radio.Group
          value={scope === "period" ? "period" : type}
          onChange={(e) => onChange(e.target.value)}
          buttonStyle="solid"
        >
          <Radio.Button value="period">本期</Radio.Button>
          <Radio.Button value="day">每日</Radio.Button>
          <Radio.Button value="month">每月</Radio.Button>
          <Radio.Button value="year">每年</Radio.Button>
        </Radio.Group>
        <Typography.Text type="secondary">
          {ready ? `${book ? "訂房日" : "入住日"} ${from} ~ ${to}` : ""}
        </Typography.Text>
      </Space>
      <div style={{ marginBottom: 12 }}>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {ready ? note : ""}
        </Typography.Text>
      </div>
    </>
  );
}
